import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default class TextImg {
  constructor(el) {
    this.el = el
    this.img = el.querySelector('.text-img--img')
    if (this.img) this.init()
  }

  init() {
    gsap.fromTo(this.img,
      { clipPath: 'inset(0 100% 0 0)', scale: 1.08 },
      {
        clipPath: 'inset(0 0% 0 0)',
        scale: 1,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: this.img,
          start: 'top 80%',
          toggleActions: 'play none none none',
        }
      }
    )
  }
}
